import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { ConfirmationToastComponent } from '../../../components/confirmation-toast/confirmation-toast.component';
import { AssessmentService } from 'src/app/services/assessment.service';
import { Title } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user.service';
import { ReportService } from 'src/app/services/report.service';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { DialogService } from 'src/app/services/dialog.service';

@Component({
  selector: 'app-request-support',
  templateUrl: './request-support.component.html',
  styleUrl: './request-support.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RequestSupportComponent implements OnInit {
  faWarning = faWarning;

  currentUser: any;
  private readonly fireRecord: any = this.data.fireRecord;

  existingLeadRequest: any = null;
  existingTeamRequest: any = null;

  displayedColumns!: string[];

  team_needs: any[];
  leadList: any[] = [];
  skillList: any[] = [];
  disableTeamOption = false;

  formValid = false;


  leadForm = this.formBuilder.group({
    additional_details: [""],
    team_leader: [false],
  });

  teamForm = this.formBuilder.group({
    additional_details: [""],
    team_members: [false],
    specific_skills: [""],
    other_skill: [""],
  });

  assessment = true;


  constructor(
    public dialogRef: MatDialogRef<RequestSupportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly formBuilder: FormBuilder,
    private readonly toast: ConfirmationToastComponent,
    private readonly assessmentService: AssessmentService,
    private readonly titleService: Title,
    private readonly userService: UserService,
    private readonly reportService: ReportService,
    private readonly dialogService: DialogService,
  ) {
    this.titleService.setTitle("BAER - Request support")
    dialogRef.disableClose = true;

    this.teamForm.valueChanges.subscribe(value => {
      this.checkValidForm();
    })
    this.leadForm.valueChanges.subscribe(value => {
      this.checkValidForm();
    })

    this.team_needs = this.assessmentService.getBAERTeamNeeds();
    this.userService.getSkillList().subscribe(skillsList => {
      skillsList.forEach((skill: any) => {
        this.skillList.push({ name: skill.text, skill_id: skill.value, checked: false });
      })
      this.skillList = this.skillList.filter((skill: any) => skill.skill_id <= 19 && skill.skill_id != 14)
    });
  }

  checkValidForm() {
    this.formValid = true
    let invalidForm = true
    if (!this.leadForm.value.team_leader && !this.teamForm.value.team_members) this.formValid = false
    if (this.teamForm.value.team_members) {
      for (let item of this.skillList) {
        if (item.checked) {
          invalidForm = false
          break
        }
      }
      if (this.skillList[this.skillList.length - 1].checked) {
        if (this.teamForm.value.other_skill == "") {
          invalidForm = true;
        }
      }
      if (invalidForm) {
        this.formValid = false
      }
    }
  }

  ngOnInit(): void {
    this.checkExistingReport()
    this.preselectOption()
  }

  preselectOption() {
    if (this.existingLeadRequest) {
      this.leadForm.patchValue({
        team_leader: true,
        additional_details: this.existingLeadRequest.additional_details,
      })
    }
    if (this.existingTeamRequest) {
      this.teamForm.patchValue({
        team_members: true,
        additional_details: this.existingTeamRequest.additional_details,
      })
    }
  }

  checkExistingReport(): void {
    if (this.data.report) {
      this.assessment = false
      this.existingLeadRequest = this.data.report.supports.find((support: any) => {
        return support.support_type == "Team Lead" && !support.support_completed
      })
      this.existingTeamRequest = this.data.report.supports.find((support: any) => {
        return ["Team Member(s)", "Shortage Team Members"].includes(support.support_type) && !support.support_completed
      })
    } else {
      this.assessment = true
      this.existingLeadRequest = this.data.fireRecord.supports.find((support: any) => {
        return support.support_type == "Team Lead" && !support.support_completed
      })
      this.existingTeamRequest = this.data.fireRecord.supports.find((support: any) => {
        return ["Team Member(s)", "Shortage Team Members"].includes(support.support_type) && !support.support_completed
      })
    }
    if (this.existingTeamRequest) {
      this.teamForm.patchValue({
        additional_details: this.existingTeamRequest.additional_details,
        other_skill: this.existingTeamRequest.other_skill
      })
      this.skillList.forEach((item: any) => {
        item.checked = this.existingTeamRequest.support_skills.search(item.name) != -1
        if (item.name == "Other") {
          item.checked = !!this.existingTeamRequest.other_skill
        }
        return { name: item.name, checked: item.checked }
      })
    }
  }

  getLeadRequest(): any {
    if (this.leadForm.value.team_leader) {
      if (this.existingLeadRequest) {
        // edit existing lead request
        this.existingLeadRequest.additional_details = this.leadForm.value.additional_details as string | undefined
        return this.existingLeadRequest
      } else {
        // create new lead request
        if (this.data.report) {
          return {
            report_id: this.data.report.report_id,
            additional_details: this.leadForm.value.additional_details as string | undefined,
            support_type: "Team Lead",
            support_completed: false,
            support_skills: "",
          }
        } else {
          return {
            assessment_id: this.fireRecord.assessment_id,
            additional_details: this.leadForm.value.additional_details as string | undefined,
            support_type: "Team Lead",
            support_completed: false,
            support_skills: "",
          }
        }
      }
    } else {
      if (this.existingLeadRequest) {
        // Delete existing lead request
      }
    }
  }

  getTeamRequest(): any {
    if (this.teamForm.value.team_members) {
      let skillSetString = this.skillList.filter((item: any) => {
        return item.checked && item.name != "Other";
      }).map((item: any) => {
        return item.name;
      }).join(", ")

      if (this.teamForm.value.other_skill) {
        if (skillSetString != "") skillSetString += ", "
        skillSetString += this.teamForm.value.other_skill
      }

      if (this.existingTeamRequest) {
        // edit existing team request
        return {
          ...this.existingTeamRequest,
          support_skills: skillSetString,
          other_skills: this.teamForm.value.other_skill as string | undefined,
          additional_details: this.teamForm.value.additional_details as string | undefined,
          support_completed: false,
        };
      } else {
        // create new lead request
        if (this.data.report) {
          return {
            report_id: this.data.report.report_id,
            support_skills: skillSetString,
            other_skill: this.teamForm.value.other_skill as string | undefined,
            additional_details: this.teamForm.value.additional_details as string | undefined,
            support_type: "Team Member(s)",
            support_completed: false,
          }
        } else {
          return {
            assessment_id: this.fireRecord.assessment_id,
            support_skills: skillSetString,
            other_skill: this.teamForm.value.other_skill as string | undefined,
            additional_details: this.teamForm.value.additional_details as string | undefined,
            support_type: "Shortage Team Members",
            support_completed: false,
          }
        }
      }
    } else {
      if (this.existingLeadRequest) {
        // Delete existing lead request
      }
    }
  }

  submitRequest(): void {

    let requests = []
    let teamRequest = this.getTeamRequest()
    let leadRequest = this.getLeadRequest()
    if (teamRequest) requests.push(teamRequest)
    if (leadRequest) requests.push(leadRequest)

    if (this.data.report) {
      this.reportService.updateReport({
        report_id: this.data.report.report_id,
        supports: requests
      }).subscribe({
        next: (response) => {
          this.toast.openSuccessSnackBar(`The interregional support request has been updated`);
          this.dialogRef.close(true);
        },
        error: (response) => {
          this.toast.openErrorSnackBar(`There was an error requesting support for ${this.fireRecord.baer_name}.`, "Please try editing the assessment again.");
          this.dialogRef.close();
        },
        complete: () => {
          this.dialogService.closeSpinner();
        }
      })
    } else {
      this.assessmentService.editAssessment({
        assessment_id: this.fireRecord.assessment_id,
        supports: requests
      }).subscribe({
        next: (response) => {
          this.toast.openSuccessSnackBar(`A support request has been submitted for ${this.fireRecord.baer_name}.`);
          this.dialogRef.close(true);
        },
        error: (response) => {
          this.toast.openErrorSnackBar(`There was an error requesting support for ${this.fireRecord.baer_name}.`, "Please try editing the assessment again.");
          this.dialogRef.close();
        },
        complete: () => {
          this.dialogService.closeSpinner();
        }
      })
    }
  }

  updateSkill(skill: any) {
    skill.checked = !skill.checked
    this.checkValidForm();
  }
}
